import { useId } from 'react';
import wordmark from '../assets/clairis-wordmark.png';
import monogramImage from '../assets/cl-probeicon.jpeg';

/** Retain the supplied artwork's glyphs; SVG masks recolor the same originals in both themes. */
export default function LoginBrand({ monogram = false }: { monogram?: boolean }) {
  const id = useId().replace(/:/g, '');
  if (monogram) {
    return (
      <svg className="login-cl-mark" viewBox="398 276 426 458" width="426" height="458" aria-hidden="true" focusable="false">
        <defs>
          <filter id={`${id}-c-ink`} colorInterpolationFilters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 -7 0 7 0 -0.18" /></filter>
          <filter id={`${id}-l-ink`} colorInterpolationFilters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 5 0 -5 0 -0.18" /></filter>
          <mask id={`${id}-c`} maskUnits="userSpaceOnUse" x="398" y="276" width="426" height="458"><image href={monogramImage} width="1600" height="1062" filter={`url(#${id}-c-ink)`} /></mask>
          <mask id={`${id}-l`} maskUnits="userSpaceOnUse" x="398" y="276" width="426" height="458"><image href={monogramImage} width="1600" height="1062" filter={`url(#${id}-l-ink)`} /></mask>
        </defs>
        <rect x="398" y="276" width="426" height="458" fill="var(--login-brand-ink)" mask={`url(#${id}-c)`} />
        <rect x="398" y="276" width="426" height="458" fill="var(--login-brand-blue)" mask={`url(#${id}-l)`} />
      </svg>
    );
  }
  return (
    <svg className="login-brand-art" viewBox="250 322 775 142" width="775" height="142" aria-hidden="true" focusable="false">
      <defs>
        <filter id={`${id}-ink`} colorInterpolationFilters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 -1 -1 -1 0 2.88" /></filter>
        <mask id={`${id}-wordmark`} maskUnits="userSpaceOnUse" x="250" y="322" width="775" height="142"><image href={wordmark} width="1280" height="853" filter={`url(#${id}-ink)`} /></mask>
      </defs>
      <g mask={`url(#${id}-wordmark)`}>
        <rect x="250" y="322" width="775" height="142" fill="var(--login-brand-ink)" />
        <rect x="503" y="322" width="201" height="142" fill="var(--login-brand-blue)" />
      </g>
    </svg>
  );
}
